import React from "react";
import { ProductDateTrackerStack } from "./ProductDateTrackerStack";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { useNavigationHeaderOptions } from "../../common/navigationHeaderOptions";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { ProductDateTracker } from "./ProductDateTracker";
import { StatusBar } from "expo-status-bar";
import {
  DEVICE_HAS_SCANNER,
  ScanToAddExpireDate,
} from "../Product/ScanToAddExpireDate";
import { AHText, Box, useTheme } from "arkh";
import { ProductDateTrackerHistory } from "./ProductDateTrackerHistory";
import { useIntl } from "react-intl";

export const ProductDateTrackerNavigator = withWebModal(() => {
  const getOptions = useNavigationHeaderOptions();
  const intl_tokens = useIntlTokens();
  const intl = useIntl();
  const theme = useTheme();
  return (
    <>
      <StatusBar style="dark" />
      <ProductDateTrackerStack.Navigator
        screenOptions={{
          contentStyle: {
            backgroundColor: theme["surface-background-light"],
          },
        }}
      >
        <ProductDateTrackerStack.Screen
          name="ProductDateTrackerMain"
          component={ProductDateTracker}
          options={({ navigation }) =>
            getOptions({
              type: "CLOSE",
              onClose: () => {
                navigation.goBack();
              },
              headerTitle: DEVICE_HAS_SCANNER
                ? () => (
                    <Box
                      style={{ flexDirection: "column", alignItems: "center" }}
                    >
                      <ScanToAddExpireDate />
                      <AHText type="subtitle" spaceTop="xsmall">
                        {intl_tokens.ExpireDates}
                      </AHText>
                    </Box>
                  )
                : intl_tokens.ExpireDates,
              more: [
                {
                  label: intl.formatMessage({
                    defaultMessage: "History",
                    description: "ProductDateTracker History Button",
                  }),
                  onPress: () => {
                    navigation.navigateDeprecated(
                      "ProductDateTrackerHistory",
                      {}
                    );
                  },
                },
              ],
            })
          }
        />
        <ProductDateTrackerStack.Screen
          name="ProductDateTrackerHistory"
          component={ProductDateTrackerHistory}
          options={({ navigation }) =>
            getOptions({
              type: "BACK",
              onBack: () => {
                navigation.goBack();
              },
            })
          }
        />
      </ProductDateTrackerStack.Navigator>
    </>
  );
}, true);
